module.exports = __webpack_public_path__ + "static/beats-video-abdeec6e35a0317ed38ec97dd3bdeb86.mp4";